// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__nKuUz","content":"Menu_content__oND4v"};